import request from '@/utils/request'

// 新增bpm业务表单
export function addBpmBusinessForm(data) {
  return request({
    url: '/sys/bizForm/add',
    method: 'post',
    data
  })
}

// 删除bpm业务表单
export function delBpmBusinessForm(id) {
  return request({
    url: '/sys/bizForm/del/' + id,
    method: 'delete'
  })
}

// 修改bpm业务表单
export function updateBpmBusinessForm(data) {
  return request({
    url: '/sys/bizForm/edit',
    method: 'put',
    data
  })
}

// 保存bpm表单单关联机构
export function saveBpmBusinessFormOrg(data) {
  return request({
    url: '/sys/bizForm/formRelate/save',
    method: 'put',
    data
  })
}

// 获取bpm业务表单详细信息
export function getBpmBusinessForm(id) {
  return request({
    url: '/sys/bizForm/info/' + id,
    method: 'get'
  })
}

// 查询bpm业务表单列表
export function listBpmBusinessForm(data) {
  return request({
    url: '/sys/bizForm/list',
    method: 'post',
    data
  })
}

// bpm业务列表-下拉
export function listBpmBusinessFormSelect(data) {
  return request({
    url: '/sys/bizForm/listAll',
    method: 'post',
    data
  })
}

// bpm流程列表-下拉
export const getFormSimpleList = (data) => {
  return request({ url: '/sys/bizForm/listSysFlowForm', method: 'post', data })
}

// bpm单关联机构查询
export function listBpmBusinessFormOrg(data) {
  return request({
    url: '/sys/bizForm/settingDetail',
    method: 'post',
    data
  })
}
